module.exports = __webpack_public_path__ + "img/00_02_kv.4c162542.jpeg";